import React from 'react';
import { type Theme, useStyletron } from 'baseui';
import { PLACEMENT, StatefulPopover, TRIGGER_TYPE } from 'baseui/popover';
const stopPropagation = (e: React.SyntheticEvent) => e.stopPropagation();
const getPopoverOverrides = (theme: Theme) => ({
  Arrow: {
    style: {
      backgroundColor: theme.colors.backgroundSecondary
    }
  },
  Inner: {
    style: {
      backgroundColor: theme.colors.backgroundSecondary,
      boxShadow: 'none',
      padding: `${theme.sizing.scale500} ${theme.sizing.scale300}`
    }
  },
  Body: {
    style: {
      backgroundColor: theme.colors.backgroundSecondary,
      boxShadow: theme.lighting.shallowBelow,
      borderRadius: theme.borders.popoverBorderRadius
    },
    props: {
      onClick: stopPropagation,
      onMouseDown: stopPropagation,
      onMouseUp: stopPropagation,
      onMouseMove: stopPropagation
    }
  }
});
type SpanPopoverPropsT = {
  content: (params: {
    close: () => void;
  }) => React.ReactNode;
  children: React.ReactNode;
  placement?: (typeof PLACEMENT)[keyof typeof PLACEMENT];
  /** When false, blocks outside-click/Esc dismissal (e.g. while an async action like tracking is running). */
  isDismissable?: boolean;
};
export const SpanPopover = ({
  content,
  children,
  placement = PLACEMENT.top,
  isDismissable = true
}: SpanPopoverPropsT) => {
  const [, theme] = useStyletron();
  return <StatefulPopover triggerType={TRIGGER_TYPE.click} placement={placement} popperOptions={{
    modifiers: {
      /* boundariesElement: 'viewport' avoids scrollParent misdetection in this nested,
       transform-positioned grid. flip lets the popover switch sides when the placement
       has no room; preventOverflow keeps it fully on-screen. */
      flip: {
        enabled: true,
        boundariesElement: 'viewport'
      },
      preventOverflow: {
        enabled: true,
        padding: 0,
        boundariesElement: 'viewport'
      }
    }
  }} showArrow dismissOnClickOutside={isDismissable} dismissOnEsc={isDismissable} overrides={getPopoverOverrides(theme)} content={({
    close
  }) => content({
    close
  })}>
      {children}
    </StatefulPopover>;
};